<template>
    <b-form-group :state="state" class="group">
        <b-form-input
            size="lg"
            type="text"
            :value="model"
            :state="state"
            class="input"
            :readonly="!editingTitle"
            :placeholder="placeholder"
            @input="onInput"
            @click="onClickEditTitle"
            @blur="onBlurTitleInput"
        />
        <b-form-invalid-feedback v-if="state === false" class="validations">
            <span v-if="!validations.required">
                {{ $t('form.validations.required') }}
            </span>
            <span v-if="!validations.maxLength">
                {{ $t('form.validations.maxLength', { value: 70 }) }}
            </span>
        </b-form-invalid-feedback>
    </b-form-group>
</template>
<script>
export default {
    props: {
        model: String,
        state: Boolean,
        validations: Object,
    },
    data() {
        return {
            editingTitle: false,
        }
    },
    computed: {
        placeholder() {
            return `Relatório sem título - ${new Date().getFullYear()}`
        },
    },
    methods: {
        onClickEditTitle() {
            this.editingTitle = true
        },
        onBlurTitleInput() {
            this.editingTitle = false
        },
        onInput(newTitle) {
            this.$emit('update:model', newTitle)
        },
    },
}
</script>
<style lang="scss" scoped>
.group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;

    .input {
        height: 35px;
        min-width: 500px;
        max-width: 600px;
        text-align: center;

        &:read-only {
            border: none;
            background-color: white;
        }
    }

    .validations {
        display: flex !important;
        justify-content: flex-end !important;
        animation-name: fadeIn;
        animation-duration: 0.3s;
    }
}
</style>
